/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Work_0_DescInputs */

const en_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog data kept fresh and structured across storefronts, ready for search and sync.`)
};

const ar_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات كتالوج محدّثة ومنظمة عبر المتاجر، جاهزة للبحث والمزامنة.`)
};

const bn_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোরে তাজা আর কাঠামোগত ক্যাটালগ ডেটা, খোঁজ ও সিঙ্কের জন্য প্রস্তুত।`)
};

const de_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogdaten über Storefronts frisch und strukturiert gehalten, bereit für Suche und Sync.`)
};

const es_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de catálogo frescos y estructurados entre tiendas, listos para buscar y sincronizar.`)
};

const fr_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de catalogue fraîches et structurées entre boutiques, prêtes pour la recherche et la synchronisation.`)
};

const pt_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de catálogo frescos e estruturados entre lojas, prontos para pesquisar e sincronizar.`)
};

const zh_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各店铺的目录数据新鲜且结构化，随时可搜可同步。`)
};

const tr_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağazalar arası taze ve yapısal katalog verisi, aramaya ve senkrona hazır.`)
};

const ru_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свежие и структурные данные каталога между витринами, готовы к поиску и синку.`)
};

const pl_svc_programmatic_seo_work_0_desc = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Świeże i strukturalne dane katalogowe między sklepami, gotowe do wyszukiwania i synchronizacji.`)
};

/**
* | output |
* | --- |
* | "Catalog data kept fresh and structured across storefronts, ready for search and sync." |
*
* @param {Svc_Programmatic_Seo_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_work_0_desc = /** @type {((inputs?: Svc_Programmatic_Seo_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "de") return de_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "es") return es_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_work_0_desc(inputs)
	return en_svc_programmatic_seo_work_0_desc(inputs)
});
export { svc_programmatic_seo_work_0_desc as "svc_programmatic-seo_work_0_desc" }